import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/ppcare";

export default function ReviewsSection() {
  return (
    <section id="reviews" className="bg-background-50 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Happy People"
            title={
              <>
                Hear From Real <span className="text-accent-500">Patients</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((review, index) => (
            <Reveal key={review.name} delay={(index % 3) * 90}>
              <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6">
                <div className="flex items-center gap-3">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-500">{review.date}</p>
                  </div>
                  <i className="ri-google-fill text-2xl text-foreground-400" />
                </div>
                <div className="mt-4 flex gap-0.5 text-accent-500">
                  {Array.from({ length: 5 }).map((_, star) => (
                    <i key={star} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  {review.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}